import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function ProcessingIcon({ className }: IconProps) {
  return (
    <svg
      width="96"
      height="83"
      viewBox="0 0 96 83"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2265)">
        <path
          d="M59.0659 64.813H27.5625V77.4523H59.0659V64.813Z"
          fill="#EAEDF8"
        />
        <path
          d="M81.8944 67.2008H4.73392C2.11464 67.2008 0 65.0782 0 62.449V4.75182C0 2.12264 2.11464 0 4.73392 0H81.9184C84.5377 0 86.6523 2.12264 86.6523 4.75182V62.449C86.6523 65.0782 84.5377 67.2008 81.9184 67.2008"
          fill="#DFE2E9"
        />
        <path
          d="M72.0662 83H14.5623C13.0484 83 11.7988 81.7698 11.7988 80.226C11.7988 78.6823 13.0244 77.4521 14.5623 77.4521H72.0421C73.556 77.4521 74.8056 78.6823 74.8056 80.226C74.8056 81.7698 73.5801 83 72.0421 83"
          fill="#DFE2E9"
        />
        <path
          d="M78.3617 61.2669H8.26608C6.96845 61.2669 5.91113 60.2056 5.91113 58.9031V8.29744C5.91113 6.99491 6.96845 5.93359 8.26608 5.93359H78.3617C79.6593 5.93359 80.7166 6.99491 80.7166 8.29744V58.879C80.7166 60.1815 79.6593 61.2428 78.3617 61.2428"
          fill="white"
        />
        <path
          d="M43.0615 34.3964H8.67452C8.45825 34.3964 8.29004 34.0587 8.29004 33.6486C8.29004 33.2386 8.45825 32.9009 8.67452 32.9009H43.0615C43.2778 32.9009 43.446 33.2386 43.446 33.6486C43.446 34.0587 43.2778 34.3964 43.0615 34.3964Z"
          fill="#00C4B3"
        />
        <path
          d="M43.3018 59.2891C42.8692 59.2891 42.5088 58.9273 42.5088 58.4931V8.70761C42.5088 8.27343 42.8692 7.91162 43.3018 7.91162C43.7343 7.91162 44.0948 8.27343 44.0948 8.70761V58.5173C44.0948 58.9514 43.7343 59.3132 43.3018 59.3132"
          fill="#00C4B3"
        />
        <path
          d="M28.7877 20.792C27.5382 21.6362 26.0243 22.1428 24.4143 22.1428C22.8042 22.1428 21.2903 21.6362 20.0408 20.792C16.9649 22.2634 14.7301 25.182 14.2736 28.7036C14.1775 29.4032 14.7301 30.0303 15.4511 30.0303H33.4015C34.1224 30.0303 34.6751 29.4032 34.579 28.7036C34.1224 25.182 31.8876 22.2634 28.8118 20.792H28.7877Z"
          fill="#00C4B3"
        />
        <path
          d="M29.9179 14.2312C29.9179 17.2946 27.4428 19.7549 24.415 19.7549C21.3872 19.7549 18.9121 17.2704 18.9121 14.2312C18.9121 11.192 21.3872 8.70752 24.415 8.70752C27.4428 8.70752 29.9179 11.192 29.9179 14.2312Z"
          fill="#00C4B3"
        />
        <path
          d="M28.7877 48.8447C27.5382 49.689 26.0243 50.1955 24.4143 50.1955C22.8042 50.1955 21.2903 49.689 20.0408 48.8447C16.9649 50.3161 14.7301 53.2347 14.2736 56.7564C14.1775 57.4559 14.7301 58.083 15.4511 58.083H33.4015C34.1224 58.083 34.6751 57.4559 34.579 56.7564C34.1224 53.2347 31.8876 50.3161 28.8118 48.8447H28.7877Z"
          fill="#00416B"
        />
        <path
          d="M29.9179 42.2839C29.9179 45.3473 27.4428 47.8076 24.415 47.8076C21.3872 47.8076 18.9121 45.3232 18.9121 42.2839C18.9121 39.2447 21.3872 36.7603 24.415 36.7603C27.4428 36.7603 29.9179 39.2447 29.9179 42.2839Z"
          fill="#00416B"
        />
        <path
          d="M91.9873 66.8631C90.954 66.8631 89.9447 66.4771 89.1518 65.6812L57.7926 34.2034C56.2306 32.6355 56.2306 30.0787 57.7926 28.5109C59.3545 26.943 61.9017 26.943 63.4636 28.5109L94.8228 59.9886C96.3848 61.5565 96.3848 64.1133 94.8228 65.6812C94.0299 66.4771 93.0206 66.8631 91.9873 66.8631Z"
          fill="#00416B"
        />
        <path
          d="M86.5565 33.6488C86.5565 46.7465 75.9833 57.3597 62.935 57.3597C49.8867 57.3597 39.3135 46.7465 39.3135 33.6488C39.3135 20.5512 49.8867 9.93799 62.935 9.93799C75.9833 9.93799 86.5565 20.5512 86.5565 33.6488Z"
          fill="#00C4B3"
        />
        <path
          d="M81.8227 33.649C81.8227 44.1174 73.3641 52.6321 62.911 52.6321C52.458 52.6321 44.0234 44.1416 44.0234 33.649C44.0234 23.1564 52.482 14.6899 62.911 14.6899C73.3401 14.6899 81.8227 23.1805 81.8227 33.649Z"
          fill="#EAEDF8"
        />
        <path
          d="M79.4677 33.6489C79.4677 42.8148 72.0664 50.2441 62.935 50.2441C53.8036 50.2441 46.4023 42.8148 46.4023 33.6489C46.4023 24.4829 53.8036 17.0537 62.935 17.0537C72.0664 17.0537 79.4677 24.4829 79.4677 33.6489Z"
          fill="#FAFBFD"
        />
        <path
          d="M75.9589 33.263C75.9349 29.8137 74.5652 26.5815 72.1381 24.1453C69.6871 21.685 66.395 20.3101 62.9106 20.3101C59.4263 20.3101 56.1582 21.6608 53.6831 24.1453C51.208 26.6056 49.8623 29.9102 49.8623 33.4077C49.8623 36.9052 51.232 40.1857 53.6831 42.6701C56.0861 45.0822 59.258 46.433 62.6463 46.5054H62.8866C66.3709 46.5054 69.639 45.1546 72.1141 42.6701L72.5707 42.2118L70.5762 40.2098L70.1196 40.6681C68.1972 42.5978 65.626 43.6591 62.9106 43.6591C60.1952 43.6591 57.624 42.5978 55.6776 40.6681C53.7552 38.7384 52.6978 36.1575 52.6978 33.4318C52.6978 30.7062 53.7552 28.1252 55.6776 26.1956C57.6 24.2659 60.1712 23.2046 62.9106 23.2046C65.65 23.2046 68.1972 24.2659 70.1196 26.1956C71.7056 27.7875 72.7149 29.8137 73.0032 32.0087H70.8646C70.5762 30.3685 69.8072 28.873 68.6057 27.6911C67.0678 26.1473 65.0493 25.3031 62.8866 25.3031C60.7239 25.3031 58.6813 26.1473 57.1434 27.6911C55.6055 29.2348 54.7644 31.2609 54.7644 33.4318C54.7644 35.6027 55.6055 37.653 57.1434 39.1726C58.6333 40.6681 60.6278 41.5123 62.7424 41.5606H62.8866C65.0493 41.5606 67.0918 40.7163 68.6057 39.1726L69.0623 38.7143L67.0678 36.7123L66.6112 37.1464C65.626 38.1354 64.3044 38.6902 62.8866 38.6902C61.4688 38.6902 60.1472 38.1354 59.1619 37.1464C58.5131 36.4952 58.0565 35.6992 57.8162 34.8308H75.9349V33.2871M62.8866 32.0087H57.8162C58.0565 31.1403 58.5131 30.3444 59.1619 29.6931C60.1472 28.7041 61.4688 28.1493 62.8866 28.1493C64.3044 28.1493 65.626 28.7041 66.6112 29.6931C67.26 30.3444 67.7166 31.1403 67.9569 32.0087H62.8866Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2265">
          <rect width="96" height="83" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
